import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { applyTheme, storedTheme } from './lib/theme.ts';
import { registerWorker } from './lib/push.ts';
import './styles.css';

/*
 * Before anything renders. The theme is an attribute on the document, and setting it after the
 * first paint means the first paint is in the wrong one — a white flash on the way into a dark
 * school, which is exactly the moment somebody notices.
 */
applyTheme(storedTheme());

/*
 * The worker, on every start rather than only when somebody subscribes.
 *
 * It is what shows a notification for a subscription made on an earlier visit, so it has to exist
 * before anybody asks for anything. Failure is silent by design: a browser that cannot do this
 * still runs the whole school, it just does not ring.
 */
void registerWorker();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
